import { ReactNode } from 'react';
import { clsx } from 'clsx';

import { OpInfoTooltip } from 'new-components/DLS/OpInfoTooltip/OpInfoTooltip';
import { OpTitle } from 'new-components/DLS/OpTitle/OpTitle';

import './OpPage.scss';

interface OpPageProps {
  children: ReactNode | ReactNode[];
  className?: string;
  title?: string | ReactNode | null;
  titleSize?: 1 | 2 | 3 | 4 | 5 | undefined;
  tooltip?: ReactNode | null;
  subtitle?: string | null;
  contentRight?: ReactNode;
  footer?: ReactNode;
  testId?: string;
  /** When true, the page fills the remaining space in its parent (for use with virtual lists, etc.) */
  fillHeight?: boolean;
}

export const OpPage = ({
  children,
  className = '',
  title,
  titleSize = 1,
  tooltip,
  subtitle,
  contentRight,
  footer,
  testId = 'op-page',
  fillHeight = false,
}: OpPageProps) => (
  <>
    <div
      className={clsx('op-page', fillHeight && 'op-page--fill', className)}
      data-testid={testId}
    >
      {(title || tooltip || subtitle || contentRight) && (
        <div className="op-page__header">
          <div>
            <div className="op-page__title-row">
              {title && (
                <OpTitle level={titleSize} className="op-page__title">
                  {title}
                </OpTitle>
              )}
              {tooltip && <OpInfoTooltip title={tooltip} />}
            </div>
            {subtitle && <div className="op-page__subtitle">{subtitle}</div>}
          </div>
          <div className="op-page__content-right">{contentRight}</div>
        </div>
      )}
      {fillHeight ? (
        <div className="op-page__content">{children}</div>
      ) : (
        children
      )}
    </div>
    {footer && <div className="op-page__footer">{footer}</div>}
  </>
);
